import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/isolation}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: false }, "auto", "isolate");
//# sourceMappingURL=isolation.js.map